/**
 * Personal Information Header - Server Component (Static)
 *
 * Renders immediately on server - no data fetching required.
 * This uses Next.js 16 PPR to show static content first, then stream dynamic data.
 */

import { User } from 'lucide-react';

export function PersonalInformationHeader() {
  return (
    <div className="flex items-center space-x-3">
      <User size={24} style={{ color: 'var(--primary-color, #22577A)' }} />
      <div>
        <h1 className="text-2xl font-bold text-text-primary">Profile & Display Settings</h1>
        <p className="text-sm text-text-secondary">Manage your personal information and display preferences</p>
      </div>
    </div>
  );
}
